import { get } from 'lodash'
import routes from '~/const/routes'

export const state = () => ({
  items: [],
  meta: {
    totalItems: null
  },
  requestParams: null
})

export const getters = {
  items: state => state.items,
  meta: state => state.meta,
  requestParams: state => state.requestParams
}

export const mutations = {
  RESET(state) {
    state.items = []
    state.meta = { totalItems: null }
    state.requestParams = null
  }
}

export const actions = {
  async getAll({ commit }, { config = {} }) {
    const { data, meta } = get(await this.$axios.get(routes.documentstatus.list(), config), 'data')

    commit(
      'AFTER_GET_ALL',
      {
        namespace: 'documentstatuses',
        items: data,
        meta,
        params: config.params
      },
      { root: true }
    )

    return { data, meta }
  }
}
